import { basicApi } from "@/api/basic";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// 定义异步请求的thunk
export const fetchMapbyRedux = createAsyncThunk(
  "map/fetchMap",
  async (params: any) => {
    const response = await basicApi.getProvinceOrCityList(params);

    return response.data;
  },
);

// 创建slice来处理状态
const mapSlice = createSlice({
  name: "map",
  initialState: {
    provinceList: [],
    // isMultiProvince: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMapbyRedux.pending, (state) => {})
      .addCase(fetchMapbyRedux.fulfilled, (state, action) => {
        state.provinceList = action.payload?.data || [];
        // state.isMultiProvince = Boolean(action.payload?.data?.length)
      })
      .addCase(fetchMapbyRedux.rejected, (state, action) => {});
  },
});

export const getProvinceList = (state: any) => state.map.provinceList;

export default mapSlice.reducer;
